import { Nullable } from 'legacy/lut/classes/models/utils'
import { useMemo } from 'react'

import { ModalDialog } from 'core-components/library/modalDialog'
import { IQBRPartner } from 'partner360/models/qbr/IQBRPartners'

import { QbrDeletePartnerFromDocumentContent } from './QbrDeletePartnerFromDocumentContent'

interface IQbrDeletePartnerFromDocumentDialogProps {
  selectedPartner: Nullable<IQBRPartner>
  closeDialog: () => void
  show: boolean
  qbrSettingsData: IQBRPartner[]
}

export const QbrDeletePartnerFromDocumentDialog = ({
  selectedPartner,
  closeDialog,
  show,
  qbrSettingsData,
}: IQbrDeletePartnerFromDocumentDialogProps) => {
  const contentProps = useMemo(
    () => ({
      selectedPartner,
      closeDialog,
      qbrSettingsData,
    }),
    [closeDialog, selectedPartner, qbrSettingsData]
  )
  return (
    <ModalDialog
      size={'xs'}
      content={QbrDeletePartnerFromDocumentContent}
      contentProps={contentProps}
      show={show}
      closeOnOutsideClick={false}
      onClose={closeDialog}
    />
  )
}
